export default {
      id: "right-arrow-usage",
      viewBox: "0 0 42 25",
      url: __webpack_public_path__ + "img/icons.df848786.svg#right-arrow",
      toString: function () {
        return this.url;
      }
    }